import { IconButton2 as IconButton, Text, theme } from '@frameio/vapor';
import { IconMagnifyingglass, IconRecent, IconX } from '@frameio/vapor-icons';
import styles from './SearchCell.module.css';

type SearchCellProps = {
  searchQuery: string;
  onClick: (query: string) => void;
  onRemove?: (query: string) => void;
  icon?: 'recent' | 'magnifyingGlass';
};

export const SearchCell = ({
  searchQuery,
  onClick,
  onRemove,
  icon = 'recent',
}: SearchCellProps) => {
  const isRemoveable = onRemove !== undefined;

  const handleRemove = (e: React.MouseEvent<any>) => {
    e.stopPropagation();
    onRemove?.(searchQuery);
  };

  const handleClick = () => {
    onClick(searchQuery);
  };

  const Icon = icon === 'recent' ? IconRecent : IconMagnifyingglass;

  return (
    <button className={styles.container} onClick={handleClick}>
      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <Icon color={theme.colors.icon.primary} size={16} />
        </div>
        <Text color="body" truncate={true} variant="body">
          {searchQuery}
        </Text>
      </div>
      {isRemoveable && (
        <div className={styles.iconButtonWrapper}>
          <IconButton
            elementType="div"
            icon={<IconX size={16} />}
            label="Remove"
            onClick={handleRemove}
            size="small"
            variant="tertiary"
          />
        </div>
      )}
    </button>
  );
};
